import { Container, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { useEffect, useState, type Ref } from "react";
import { useDispatch, useSelector } from "react-redux";
import { asyncGetDropdownCategories } from "../../../shared/components/categoriesDropdown/actions";
import { Header } from "../../../shared/components/header";
import { useInIframe } from "../../../shared/hooks";
import { useFilterPagination } from "../../../shared/hooks/useFilterPagination";
import type { RootState } from "../../../store";
import { GlossaryTable } from "../../components/glossaryTable/glossaryTable";
import { getGlossaryService } from "../../service";
import { useStyles } from "./glossary.styles";

export const Glossary = ({ navigation }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isInIframe = useInIframe();

  useEffect(() => {
    dispatch(asyncGetDropdownCategories());
  }, [dispatch]);

  const dropdownCategories = useSelector(
    (state: RootState) => state.categoriesReducer.dropdownCategories
  );

  const { infiniteRef, sourceData, debouncedHandleFilterChange, isFetching } =
    useFilterPagination(
      getGlossaryService,
      50,
      "glossaryId",
      undefined,
      "glossary"
    );

  const [search, setSearch] = useState({ keyword: "", categoryId: "" });

  const handleOnChange = (event) => {
    const { value, name } = event.target;
    setSearch({ ...search, [name]: value });
    debouncedHandleFilterChange(value === "All" ? 0 : value, name);
  };

  const filters = [
    {
      name: "keyword",
      id: "keyword",
      type: "text",
      label: "Keyword",
      value: search.keyword,
      onChange: handleOnChange,
    },
    {
      name: "categoryId",
      id: "categoryId",
      type: "dropDown",
      label: "Category",
      value: search.categoryId,
      options: [
        { text: "All", id: "All" },
        ...dropdownCategories.map((category) => ({
          text: category.name,
          id: category.categoryId,
        })),
      ],
      onChange: handleOnChange,
    },
  ];

  return (
    <Header navigation={navigation}>
      <Container
        className={classes.container}
        ref={infiniteRef as Ref<HTMLDivElement>}
      >
        {!isInIframe && (
          <Grid item xs={12}>
            <Typography
              component="h5"
              variant="h5"
              align="left"
              className={classes.glossaryTitle}
            >
              Glossary
            </Typography>
          </Grid>
        )}
        <GlossaryTable
          filters={filters}
          glossaryItems={sourceData}
          isFetching={isFetching}
        />
      </Container>
    </Header>
  );
};

Glossary.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

Glossary.defaultProps = {
  navigation: [],
};
